import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './AvailBoardDetail.js';
import RichText from '@synergycms_core/components/generic/RichText';
import Image from '@synergycms_core/components/generic/Image';
import { AvailRateDetail } from '../AvailRateDetail';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import { contextualizeAppConfig } from '@synergycms_core/store/app/utils';
import { Map } from 'immutable';
import Button from '@synergycms_core/components/generic/Button';

const AvailBoardDetail = class AvailBoardDetail extends React.Component {
  static displayName = 'AvailBoardDetail';
  constructor(props){
    super(props);
    this.state= {
      visible: !props.config.isTypeFull
    }
  }

  toggle = ()=> {
    this.setState({visible : !this.state.visible});
  }

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    let {boardAvail} = config;
    const {
      selectRoomRate,
      boardId,
      roomId,
      serviceId,
      segment,
      occupGroupId,
      adults,
      childs,
      babies,
      childsInfo,
      hotelConfig,
      isTypeFull
    } = config;

    const isDesk = theme.width > 901;
    const hideBoardGrouping = hotelConfig.get("hide_board_grouping", false);
    const firstBoard = boardAvail.first() || Map();
    const boardName = firstBoard.get('board_name');
    const boardDesc = firstBoard.get('board_description', false);
    const ToolTipBoard = () =>
      boardDesc ? (
        <div className={[classes.boardInfo]}>
          <TooltipWrapper
            popover={<span>{boardDesc}</span>}
            bottomLimit={100}
            popoverStyle={classes.boardTooltip}
            typeTooltip={'boardTooltip-' + boardId + '-' + roomId}
            pointerStyle={classes.tooltipPointerStyle}
            posX={'middle'}
            posY={'bottom'}>
            <Image unicodeContent="e143" innerStyle={['gold']}/>
          </TooltipWrapper>
        </div>
      ) : (
        ''
      );



    let map = Map({refundable:false, noRefundable:false, bfr:false});
    boardAvail.forEach((rateAvail, key) => {
      let visible = false;
      if(!isTypeFull) {
        visible = true;
      } else if (key === "bfr" && !map.get("bfr")) {
        map = map.set("flex", true);
        visible = true;
      } else if(rateAvail.get("refundable") && !map.get("refundable")) {
        map = map.set("refundable", true);
        visible = true;
      } else if (rateAvail.get("refundable") === false && !map.get("noRefundable")) {
        map = map.set("noRefundable", true);
        visible = true;
      }
      boardAvail = boardAvail.setIn([key,"visible"], visible)
    });

    const visibleShape = boardAvail.filter((rate)=> rate.get("visible")).size === boardAvail.size;

    const toggleMoreRatesBlock = isTypeFull && (
      <div className={classes.moreRatesToggle}>
        <RichText
          text={this.state.visible ? '_%ver menos tarifas%_' : '_%ver más tarifas%_'}
          innerStyle={[visibleShape && classes.hidden, 'roboto14Gold']}
          ucFirst={true}
          translate={true}
        />
        <Button innerStyle={[visibleShape && classes.hidden, classes.vShape, this.state.visible && classes.vShapeReverse, 'mainColor']}></Button>
      </div>
    );

    return (
      <div className={[boardAvail.size > 1 ? classes.doubleRate : classes.singleRate]}>
        {!hideBoardGrouping &&
          <div onClick={this.toggle} className={[classes.boardTitle]}>
            <RichText innerStyle={['roboto16Black']} text={boardName} tabIndex={0}/>
            {isDesk && toggleMoreRatesBlock}
            <ToolTipBoard/>
          </div>
        }
        <ul className={classes.hotelSelection}>
          {boardAvail.keySeq().map((uniqueRefType) => {
            const rateAvail = boardAvail.get(uniqueRefType);
            return (
               <li style={{ display: rateAvail.get("visible") || this.state.visible ? "block" : "none" }} key={uniqueRefType}>
                <AvailRateDetail
                  rateAvail={rateAvail}
                  selectRoomRate={selectRoomRate}
                  innerStyle={['defaultStyle']}
                  boardId={boardId}
                  roomId={roomId}
                  serviceId={serviceId}
                  segment={segment}
                  uniqueRefType={uniqueRefType}
                  occupGroupId={occupGroupId}
                  adults={adults}
                  childs={childs}
                  babies={babies}
                  childsInfo={childsInfo}
                />
              </li>
            );
          })}
          {((!hideBoardGrouping && !isDesk) || hideBoardGrouping) &&
            <div onClick={this.toggle}>
              {toggleMoreRatesBlock}
              <ToolTipBoard/>
            </div>
          }
        </ul>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  const config = contextualizeAppConfig(store, store.getIn(['customer', 'current_hotel']));
  return {
    isTypeFull : config.get("show_all_rates_per_room") === "full",
    hotelConfig : config,
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'boardAvail',
    'boardId',
    'selectRoomRate',
    'roomId',
    'segment',
    'serviceId',
    'occupGroupId',
    'adults',
    'childs',
    'babies',
    'isTypeFull',
    'childsInfo',
    'hotelConfig',
  ]),
  withThemeJSS({ styleFile, index: 300 })
)(AvailBoardDetail);
